import { useCallback as c } from "react";
import { useMultiSelectContext as f } from "../MultiSelectContext.js";
const y = ({
  selectedValue: o,
  searchValue: n
}) => o.some((i) => i.value === n), b = ({
  createdSections: o,
  removedOption: n
}) => o.some((i) => i.options.some((t) => t.label === n.label)), u = ({
  selectedValue: o,
  createdSections: n,
  setCreatedSections: i,
  searchValue: t,
  onChange: s,
  creatableProps: m
}) => {
  const {
    addCreatedSection: p,
    isSuggestionVisible: l
  } = f();
  return {
    handleKeyDown: c((e) => {
      if (m && (e.key === "Enter" && t.trim() && l && !y({
        selectedValue: o,
        searchValue: t
      }) && p(), e.key === "Backspace" && !t)) {
        const r = o.slice(0, o.length - 1), a = o[o.length - 1];
        b({
          createdSections: n,
          removedOption: a
        }) && i([{
          options: r
        }]), s(r);
      }
    }, [o, t])
  };
};
export {
  u as useKeyboard
};
